import { ref } from 'vue'

// Create a reactive loading state that can be shared across components
const isLoading = ref(false)

export function useLoading() {
  // Start loading
  const startLoading = () => {
    isLoading.value = true
  }

  // Stop loading
  const stopLoading = () => {
    isLoading.value = false
  }

  return {
    isLoading,
    startLoading,
    stopLoading
  }
}